import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { QuoteRefusalReasonService } from '../../../core/services/purchases/quote-refusal-reason/quote-refusal-reason.service'
import { PurchasesQuoteRequestService } from '../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'

@Component({
  selector: 'modal-purchases-refuse-request',
  imports: [
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatButton,
    MatIcon,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    MatProgressSpinner,
  ],
  templateUrl: './modal-purchases-refuse-request.component.html',
  styleUrl: './modal-purchases-refuse-request.component.scss',
  standalone: true,
})
export class ModalPurchasesRefuseRequestComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private quoteRefusalReasonService: QuoteRefusalReasonService,
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalPurchasesRefuseRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  @Output() responseRefuse = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  listReason: any[] = []
  loading = false
  loadingReason = false

  ngOnInit(): void {
    this.createForm()
    this.getReasonsList()
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      motivoSelected: ['', [Validators.required]],
    })
  }

  getReasonsList() {
    this.loadingReason = true
    this.quoteRefusalReasonService.listQuoteRefusalReason().subscribe({
      next: (response: ResponseRequestModel) => {
        // lista vazia volta como 206 com data null
        this.listReason = response.data ?? []
      },
      error: (err: ErrorRequestModel) => {
        this.listReason = []
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingReason = false
      },
    })
  }

  refuseRequest() {
    this.loading = true
    this.purchasesQuoteRequestService
      .refusePurchasesQuoteRequest(this.createModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseRefuse.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  createModel() {
    return {
      solicitacaoId: this.item.id,
      motivoId: this.form.controls['motivoSelected'].value,
    }
  }
}
